import React, { useState, useEffect } from "react";
import Close from "../../assets/images/icons/close.svg";
import { useTranslation } from "react-i18next";

const CommonFilter = ({ bookingDate, tagListData, onApply, onClose, selectedZone }) => {

    const zoneKey = `mapFilters_${selectedZone?.Id}`;
    const { t } = useTranslation();

    // STATES (MULTI SELECT)
    const [selectedFacility, setSelectedFacility] = useState([]);
    const [selectedVehicleSize, setSelectedVehicleSize] = useState([]);
    const [selectedVehicleFuel, setSelectedVehicleFuel] = useState([]);
    const [selectedTag, setSelectedTag] = useState([]);
    const [selectedVehicleShareable, setSelectedVehicleShareable] = useState([]);
    const [selectedVehicleAccessible, setSelectedVehicleAccessible] = useState([]);

    const [filterStartTime, setFilterStartTime] = useState("");
    const [filterEndTime, setFilterEndTime] = useState("");

    const [dateforfullday, setDateforfullday] = useState("");
    const [monthforfullday, setMonthforfullday] = useState("");
    const [yearforfullday, setYearforfullday] = useState("");

    const [showFromOptions, setShowFromOptions] = useState(false);
    const [showToOptions, setShowToOptions] = useState(false);

    const normalizeMultiValue = (value) => {
        if (Array.isArray(value)) return value;
        if (typeof value === "string") {
            if (!value.trim()) return [];
            return value
                .split(",")
                .map((item) => item.trim())
                .filter(Boolean)
                .map((item) => {
                    const numericValue = Number(item);
                    return Number.isNaN(numericValue) ? item : numericValue;
                });
        }
        return [];
    };

    // TOGGLE FUNCTION
    const toggleSelection = (value, state, setState) => {
        if (state.includes(value)) {
            setState(state.filter(item => item !== value));
        } else {
            setState([...state, value]);
        }
    };
    useEffect(() => {
        handleDateFormat();
    }, [bookingDate, t]);
    // LOAD FROM SESSION (ZONE BASED)
    useEffect(() => {
        if (!selectedZone?.Id) return;

        const saved = sessionStorage.getItem(zoneKey);
        if (saved) {
            const data = JSON.parse(saved);

            setSelectedFacility(normalizeMultiValue(data.FacilityFilter));
            setSelectedVehicleSize(normalizeMultiValue(data.VehicleTypeFilter));
            setSelectedVehicleFuel(normalizeMultiValue(data.FuelFilter));
            setFilterStartTime(data.FilterStartTime || "");
            setFilterEndTime(data.FilterEndTime || "");
            setSelectedTag(normalizeMultiValue(data.TagsFilter));
            setSelectedVehicleAccessible(normalizeMultiValue(data.AccessibleFilter));
            setSelectedVehicleShareable(normalizeMultiValue(data.ShareableFilter));
        }
    }, [selectedZone, zoneKey]);

    // VALIDATION
    useEffect(() => {
        if (filterStartTime && filterEndTime && filterStartTime >= filterEndTime) {
            alert("End time must be greater than start time");
            setFilterEndTime("");
        }
    }, [filterStartTime, filterEndTime]);

    // BUILD API PAYLOAD
    const buildPayload = () => {
        const safeSelectedFacility = normalizeMultiValue(selectedFacility);
        const safeSelectedVehicleSize = normalizeMultiValue(selectedVehicleSize);
        const safeSelectedVehicleFuel = normalizeMultiValue(selectedVehicleFuel);
        const safeSelectedTag = normalizeMultiValue(selectedTag);
        const safeSelectedVehicleAccessible = normalizeMultiValue(selectedVehicleAccessible);
        const safeSelectedVehicleShareable = normalizeMultiValue(selectedVehicleShareable);
        const enabledFacilityOptions = (tagListData?.Facility || []).filter((f) => f.Enable === 1);
        const facilityFilterValue =
            enabledFacilityOptions.length === 2 &&
            safeSelectedFacility.length === enabledFacilityOptions.length
                ? ""
                : safeSelectedFacility.join(",");

        return {
            FacilityFilter: facilityFilterValue,
            VehicleTypeFilter: safeSelectedVehicleSize.join(","), // "1,3"
            FuelFilter: safeSelectedVehicleFuel.join(","),   // "2"
            FilterStartTime: filterStartTime || "",
            FilterEndTime: filterEndTime || "",
            TagsFilter: safeSelectedTag.join(","),
            AccessibleFilter: safeSelectedVehicleAccessible.join(","),
            ShareableFilter: safeSelectedVehicleShareable.join(",")


        };
    };

    // SAVE TO SESSION
    const saveToSession = (payload) => {
        sessionStorage.setItem(zoneKey, JSON.stringify({
            FacilityFilter: selectedFacility,
            FacilityFilterApiValue: payload.FacilityFilter,
            VehicleTypeFilter: selectedVehicleSize,
            FuelFilter: selectedVehicleFuel,
            FilterStartTime: filterStartTime,
            FilterEndTime: filterEndTime,
            TagsFilter: selectedTag,
            AccessibleFilter: selectedVehicleAccessible,
            ShareableFilter: selectedVehicleShareable
        }));
    };

    // APPLY
    const handleApply = () => {
        const payload = buildPayload();

        saveToSession(payload);

        console.log("Applied Filters:", payload);

        onApply(payload);
        onClose();
    };

    // RESET
    const handleReset = () => {
        setSelectedFacility([]);
        setSelectedVehicleSize([]);
        setSelectedVehicleFuel([]);
        setFilterStartTime("");
        setFilterEndTime("");
        setSelectedTag([]);
        setSelectedVehicleAccessible([]);
        setSelectedVehicleShareable([]);

        sessionStorage.removeItem(zoneKey);

        onApply({
            FacilityFilter: "",
            VehicleTypeFilter: "",
            FuelFilter: "",
            FilterStartTime: "",
            FilterEndTime: "",
            TagsFilter: "",
            AccessibleFilter: "",
            ShareableFilter: ""
        });
    };

    const handleDateFormat = () => {
        // 1. Split the string by the hyphen
        // If changeddate is "2026-01-12", this creates an array: ["2026", "01", "12"]
        const dateParts = bookingDate.split('-');

        // 2. Destructure the array into individual variables
        setYearforfullday(dateParts[0]);
        // const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        const monthNames = [
            t("January"),
            t("February"),
            t("March"),
            t("April"),
            t("May"),
            t("June"),
            t("July"),
            t("August"),
            t("September"),
            t("October"),
            t("November"),
            t("December")
        ];
        const monthName = monthNames[parseInt(dateParts[1]) - 1];
        setMonthforfullday(monthName);
        setDateforfullday(dateParts[2]);

        // console.log("Formatted Date:", `${day}-${month}`);
        // return `${day}-${month}-${year}`;
    };

    const handleFromSelect = (time) => {
        setFilterStartTime(time);
        setShowFromOptions(false);

        if (filterEndTime && time >= filterEndTime) {
            setFilterEndTime("");
        }
    };

    const handleToSelect = (time) => {
        if (filterStartTime && time <= filterStartTime) return;

        setFilterEndTime(time);
        setShowToOptions(false);
    };

    return (
        <div className="modal-body">
            {/* CLOSE */}
            <div className="close-modal">
                <img src={Close} alt="Close" onClick={onClose} />
            </div>

            <div className="pt-4">
                <h5 className="popup-title">{t("filters")}</h5>
            </div>

            {/* <div className="date-with-credit d-flex align-items-center justify-content-between pt-2">
                <div id="selectedDate" className="selected-current-date">
                <span>{dateforfullday}</span>
                <span> {monthforfullday} {yearforfullday} </span>
            </div>
            </div> */}

            {/* START TIME */}
                {tagListData?.TimeInterval?.length > 0 && (
            <div className="custom-timepicker mt-3">
                <h6 className="popup-inner-title">{t("react_select_time")}</h6>

                <div className="time-selection">
                    <div className="row">

                        {/* FROM */}
                        <div className="col-md-6 rightArrow">
                            <div className="time-alignment pl20">
                                <label onClick={() => {
                                    setShowFromOptions(!showFromOptions);
                                    setShowToOptions(false);
                                }}>
                                    {t("from")}
                                </label>

                                <input
                                    type="text"
                                    readOnly
                                    value={filterStartTime}
                                    placeholder="00:00"
                                    onClick={() => {
                                        setShowFromOptions(!showFromOptions);
                                        setShowToOptions(false);
                                    }}
                                />
                            </div>
                        </div>

                        {/* TO */}
                        <div className="col-md-6">
                            <div className="time-alignment pl40">
                                <label onClick={() => {
                                    setShowToOptions(!showToOptions);
                                    setShowFromOptions(false);
                                }}>
                                    {t("react_to")}
                                </label>

                                <input
                                    type="text"
                                    readOnly
                                    value={filterEndTime}
                                    placeholder="00:00"
                                    onClick={() => {
                                        setShowToOptions(!showToOptions);
                                        setShowFromOptions(false);
                                    }}
                                />
                            </div>
                        </div>

                    </div>
                </div>

                {/* FROM OPTIONS */}
                {showFromOptions && (
                    <div className="time-options">
                        {tagListData?.TimeInterval?.map((time, i) => (
                            <div
                                key={i}
                                className={`time-option ${filterStartTime === time ? "selected" : ""}`}
                                onClick={() => handleFromSelect(time)}
                            >
                                {time}
                            </div>
                        ))}
                    </div>
                )}

                {/* TO OPTIONS */}
                {showToOptions && (
                    <div className="time-options">
                        {tagListData?.TimeInterval?.map((time, i) => (
                            <div
                                key={i}
                                className={`time-option 
                        ${filterEndTime === time ? "selected" : ""} 
                        ${filterStartTime && time <= filterStartTime ? "disable" : ""}
                    `}
                                onClick={() => {
                                    if (!(filterStartTime && time <= filterStartTime)) {
                                        handleToSelect(time);
                                    }
                                }}
                            >
                                {time}
                            </div>
                        ))}
                    </div>
                )}
            </div>
                )}

            {/* FACILITY */}
            <div className="filter-facilities mt-3">
                {tagListData?.Facility?.length > 0 && (
                    <div>
                        <h6 className="popup-inner-title">{t("facility")}</h6>
                        <div className="inline-btn-tags tags-btn d-flex flex-wrap">
                            {tagListData.Facility
                                .filter(f => f.Enable === 1)
                                .map(f => (
                                    <button
                                        key={f.Id}
                                        type="button"
                                        className={` ${selectedFacility.includes(f.Id) ? "selected" : ""}`}
                                        onClick={() => toggleSelection(f.Id, selectedFacility, setSelectedFacility)}
                                    >
                                        {f.Name}
                                    </button>
                                ))}
                        </div>
                    </div>
                )}
            </div>

            {/* VEHICLE Type */}
            <div className="filter-facilities mt-3">
                {tagListData?.VehicleSize?.length > 0 && (
                    <div className="form-group mt-3">
                        <h6 className="popup-inner-title">{t("type")}</h6>
                        <div className="inline-btn-tags tags-btn d-flex flex-wrap">
                            {tagListData.VehicleSize.map(v => (
                                <button
                                    key={v.Id}
                                    type="button"
                                    className={`${selectedVehicleSize.includes(v.Id) ? "selected" : ""}`}
                                    onClick={() => toggleSelection(v.Id, selectedVehicleSize, setSelectedVehicleSize)}
                                >
                                    {v.Name}
                                </button>
                            ))}
                        </div>
                    </div>
                )}
            </div>

            {/* VEHICLE FUEL */}
            <div className="filter-facilities mt-3">
                {tagListData?.VehicleFuel?.length > 0 && (
                    <div className="form-group mt-3">
                        <h6 className="popup-inner-title">{t("fuel")}</h6>
                        <div className="inline-btn-tags tags-btn d-flex flex-wrap">
                            {tagListData.VehicleFuel.map(v => (
                                <button
                                    key={v.Id}
                                    type="button"
                                    className={` ${selectedVehicleFuel.includes(v.Id) ? "selected" : ""}`}
                                    onClick={() => toggleSelection(v.Id, selectedVehicleFuel, setSelectedVehicleFuel)}
                                >
                                    {v.Name}
                                </button>
                            ))}
                        </div>
                    </div>
                )}
            </div>

            {/* TAGS */}
            <div className="filter-facilities mt-3">
                {tagListData?.Tags?.length > 0 && (
                    <div className="form-group mt-3">
                        <h6 className="popup-inner-title">{t("react_tags")}</h6>
                        <div className="inline-btn-tags tags-btn d-flex flex-wrap">
                            {tagListData.Tags.map(v => (
                                <button
                                    key={v.Id}
                                    type="button"
                                    className={` ${selectedTag.includes(v.Id) ? "selected" : ""}`}
                                    onClick={() => toggleSelection(v.Id, selectedTag, setSelectedTag)}
                                >
                                    {v.Name}
                                </button>
                            ))}
                        </div>
                    </div>
                )}
            </div>

            {/* VehicleAccessible */}
            <div className="filter-facilities mt-3">
                {tagListData?.VehicleAccessible?.length > 0 && (
                    <div className="form-group mt-3">
                        <h6 className="popup-inner-title">{t("label_accessible_category")}</h6>
                        <div className="inline-btn-tags tags-btn d-flex flex-wrap">
                            {tagListData.VehicleAccessible.map(v => (
                                <button
                                    key={v.Id}
                                    type="button"
                                    className={` ${selectedVehicleAccessible.includes(v.Id) ? "selected" : ""}`}
                                    onClick={() => toggleSelection(v.Id, selectedVehicleAccessible, setSelectedVehicleAccessible)}
                                >
                                    {v.Name}
                                </button>
                            ))}
                        </div>
                    </div>
                )}
            </div>

            {/* VehicleShareable */}
            <div className="filter-facilities mt-3">
                {tagListData?.VehicleShareable?.length > 0 && (
                    <div className="form-group mt-3">
                        <h6 className="popup-inner-title">{t("label_shareable_category")}</h6>
                        <div className="inline-btn-tags tags-btn d-flex flex-wrap">
                            {tagListData.VehicleShareable.map(v => (
                                <button
                                    key={v.Id}
                                    type="button"
                                    className={` ${selectedVehicleShareable.includes(v.Id) ? "selected" : ""}`}
                                    onClick={() => toggleSelection(v.Id, selectedVehicleShareable, setSelectedVehicleShareable)}
                                >
                                    {v.Name}
                                </button>
                            ))}
                        </div>
                    </div>
                )}
            </div>

            {/* ACTION BUTTONS */}
            <div className="divider-line"></div>
            <div className="approval-action-btn d-flex justify-content-between">
                <button onClick={handleReset} className="main-btn outline-gray-btn">
                    {t("reset")}
                </button>
                {/* <button onClick={onClose} className="btn btn-secondary">
                    Cancel
                </button> */}
                <button onClick={handleApply} className="main-btn fill-green-btn">
                    {t("approve")}
                </button>
            </div>
        </div>
    );
};

export default CommonFilter;
